module.exports = __webpack_public_path__ + "img/gente_resolve_branco.8bb8dd88.png";